import React from 'react';

export default function HomeConsult({ onGoTo }) {
  return (
    <section
      className="consult"
      aria-labelledby="consult-title"
      style={{
        background:
          'linear-gradient(120deg, rgba(29, 36, 48, 0.95), rgba(167, 44, 51, 0.9)), url(/assets/dalmaf-hero.png) center / cover',
      }}
    >
      <div>
        <p className="eyebrow">Still confused about your business needs?</p>
        <h2 id="consult-title" className="dh-title-2">
          Consult with DALMAF experts today.
        </h2>
      </div>
      <a className="btn btn-light" href="/schedule-meet" onClick={onGoTo('/schedule-meet')}>
        Schedule Meeting
      </a>
    </section>
  );
}
